import React from 'react';

export default function Can({ children, renderable }) {
  if (!renderable) {
    return null;
  }

  return <>{children}</>;
}
